import React, { useState } from 'react';
import {
  Button,
  Container,
  TextField,
  Table,
  Modal,
  TableBody,
  TableCell,
  Box,
  Typography,
  TableContainer,
  IconButton,
  TableHead,
  TableRow,
  Paper,
  styled,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  useTheme,
} from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
  Close as CloseIcon,
  KeyboardDoubleArrowLeft as ChevronLeft,
  KeyboardDoubleArrowRight as ChevronRight,
} from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const CustomTableScrollbar = styled('div')(({ theme }) => ({
  '&::-webkit-scrollbar': {
    height: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Requisition = () => {
  const theme = useTheme();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showUserGuideModal,setShowUserGuideModal]=useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [searchTerm, setSearchTerm] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddRequisitionModal, setShowAddRequisitionModal] = useState(false);
  const [showEditRequisitionModal, setShowEditRequisitionModal] = useState(false);
  const [selectedRequisition, setSelectedRequisition] = useState({ requisitionId: null, requisitionNo: '' });
  const [formData, setFormData] = useState({
    requisitionNo: '',
    requisitionDate: '',
    purchaseDate: '',
    remarks: '',
  });

  // Static data for requisition
  const staticRequisitionData = [
    { requisitionId: 1, requisitionNo: 'REQ001', requisitionDate: '2023-10-01', purchaseDate: '2023-10-15', remarks: 'Urgent' },
    { requisitionId: 2, requisitionNo: 'REQ002', requisitionDate: '2023-10-02', purchaseDate: '2023-10-16', remarks: 'Standard' },
    { requisitionId: 3, requisitionNo: 'REQ003', requisitionDate: '2023-10-03', purchaseDate: '2023-10-17', remarks: 'High Priority' },
    { requisitionId: 4, requisitionNo: 'REQ004', requisitionDate: '2023-10-04', purchaseDate: '2023-10-18', remarks: 'Low Priority' },
    { requisitionId: 5, requisitionNo: 'REQ005', requisitionDate: '2023-10-05', purchaseDate: '2023-10-19', remarks: 'Urgent' },
    { requisitionId: 6, requisitionNo: 'REQ006', requisitionDate: '2023-10-06', purchaseDate: '2023-10-20', remarks: 'Standard' },
  ];

  // Static data for remark options (for dropdown in forms)
  const remarkOptions = [
    { id: 1, name: 'Urgent' },
    { id: 2, name: 'Standard' },
    { id: 3, name: 'High Priority' },
    { id: 4, name: 'Low Priority' },
  ];

  const handleAddRequisition = () => {
    setFormData({
      requisitionNo: '',
      requisitionDate: '',
      purchaseDate: '',
      remarks: '',
    });
    setShowAddRequisitionModal(true);
  };

  const handleEdit = (requisition) => {
    setSelectedRequisition({ requisitionId: requisition.requisitionId, requisitionNo: requisition.requisitionNo });
    setFormData({
      requisitionNo: requisition.requisitionNo,
      requisitionDate: requisition.requisitionDate,
      purchaseDate: requisition.purchaseDate,
      remarks: requisition.remarks,
    });
    setSnackbarMessage('Updated successfully!');
  setOpenSnackbar(true);
  setSnackbarSeverity("success");
  };

  const handleDelete = (requisitionId, requisitionNo) => {
    setSelectedRequisition({ requisitionId, requisitionNo });
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setSnackbarMessage('Deleted successfully!');
  setOpenSnackbar(true);
  setSnackbarSeverity("success");
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (!formData.requisitionNo || !formData.requisitionDate || !formData.purchaseDate || !formData.remarks) {
      setSnackbarMessage('plz fill rquired field!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("error");
      return;
    }
    setSnackbarMessage('Requisition Added Successfully');
    setOpenSnackbar(true);
  setSnackbarSeverity("success");
    setShowAddRequisitionModal(false);
    setFormData({
      requisitionNo: '',
      requisitionDate: '',
      purchaseDate: '',
      remarks: '',
    });
  };

  const handleUpdate = () => {
    if (!formData.requisitionNo || !formData.requisitionDate || !formData.purchaseDate || !formData.remarks) {
     setSnackbarMessage('plz fill rquired field!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("error");
      return;
    }
    setSnackbarMessage('Requisition Updated Successfully');
    setOpenSnackbar(true);
    setShowEditRequisitionModal(false);
  };

  const handleReset = () => {
    setFormData({
      requisitionNo: '',
      requisitionDate: '',
      purchaseDate: '',
      remarks: '',
    });
  };

  const handleCancel = () => {
    setShowEditRequisitionModal(false);
  };

  const filteredData = staticRequisitionData.filter((requisition) =>
    requisition.requisitionNo.toLowerCase().includes(searchTerm.toLowerCase()) ||
    requisition.requisitionDate.toLowerCase().includes(searchTerm.toLowerCase()) ||
    requisition.purchaseDate.toLowerCase().includes(searchTerm.toLowerCase()) ||
    requisition.remarks.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Container>
      <Box sx={{ display: 'flex', alignItems: 'center',justifyContent:'space-between', mb: 1, p: 2, boxShadow: 'none', maxWidth: '100%', boxSizing: 'border-box' }}>
        <Box sx={{display:'flex',justifyContent:'center',alignItems:'center',gap:2}}>
       <TextField
                                  variant="outlined"
                                  placeholder="Search..."
                                  value={searchTerm}
                                  onChange={(e) => setSearchTerm(e.target.value)}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <SearchIcon
                                          sx={{
                                            color: theme.palette.primary.main,
                                            marginLeft: 1.5,
                                            fontSize: 24,
                                          }}
                                        />
                                      </InputAdornment>
                                    ),
                                    endAdornment: searchTerm && (
                                      <InputAdornment position="end">
                                        <IconButton
                                          size="small"
                                          onClick={() => setSearchTerm('')}
                                          sx={{
                                            color: "grey",
                                            marginRight: 1,
                                          }}
                                        >
                                          <CloseIcon fontSize="small" />
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                    sx: {
                                      borderRadius: '30px',
                                      backgroundColor: theme.palette.mode === 'dark'
                                        ? 'rgba(255, 255, 255, 0.15)'
                                        : 'rgba(255, 255, 255, 1)',
                                      boxShadow: theme.palette.mode === 'dark'
                                        ? '0 2px 8px rgba(0, 0, 0, 0.3)'
                                        : '0 2px 8px rgba(0, 0, 0, 0.1)',
                                      '& .MuiOutlinedInput-notchedOutline': {
                                        border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
                                      },
                                      '&:hover': {
                                        backgroundColor: theme.palette.mode === 'dark'
                                          ? 'rgba(255, 255, 255, 0.2)'
                                          : 'rgba(240, 240, 240, 1)',
                                        boxShadow: theme.palette.mode === 'dark'
                                          ? '0 2px 12px rgba(0, 0, 0, 0.4)'
                                          : '0 2px 12px rgba(0, 0, 0, 0.15)',
                                      },
                                      '&.Mui-focused': {
                                        backgroundColor: theme.palette.mode === 'dark'
                                          ? 'rgba(255, 255, 255, 0.25)'
                                          : 'rgba(255, 255, 255, 1)',
                                        boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
                                        '& .MuiOutlinedInput-notchedOutline': {
                                          border: `2px solid ${theme.palette.primary.main}`,
                                        },
                                      },
                                      paddingLeft: 1.5,
                                      height: '50px',
                                      transition: 'all 0.3s ease',
                                    },
                                  }}
                                  sx={{
                                    width: 350,
                                    maxWidth: '100%',
                                    '& .MuiInputBase-input': {
                                      padding: '10px 14px',
                                      color: theme.palette.text.primary,
                                      fontWeight: 500,
                                    },
                                  }}
                                />
        <Button
          variant="contained"
          onClick={handleAddRequisition}
          sx={{
            ml: 2,
            width: "100px",
            height: "50px",
            borderRadius: "10px",
            padding: "10px 0",
            fontWeight: 'bold',
            backgroundColor: theme.palette.primary.main,
            '&:hover': { backgroundColor: theme.palette.primary.dark },
          }}
          startIcon={<AddIcon />}
        >
          ADD
        </Button>
        </Box>
         <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  mb: 2,
                }}
              >
                <IconButton
                  onClick={() => setShowUserGuideModal(true)}
                  sx={{
                    width: 60,
                    height: 60,
                    borderRadius: '50%',
                    minWidth: 0, // Remove MUI's default padding
                  }}
                >
                  <InfoOutlineIcon sx={{ fontSize: 30 }} />
                </IconButton>
              </Box>
      </Box>
      <Paper
        elevation={3}
        sx={{
          paddingBottom: 0,
          maxWidth: '100%',
          boxSizing: 'border-box',
          mx: 'auto',
          backgroundColor: theme.palette.background.paper,
          borderRadius: '16px',
        }}
      >
        <CustomTableScrollbar sx={{ width: '100%', overflowX: 'auto' }}>
          <TableContainer sx={{ width: '100%', borderRadius: '16px' }}>
            <Table
              sx={{
                '& .MuiTableHead-root .MuiTableCell-root': {
                  fontWeight: 'bold',
                  backgroundColor: theme.palette.primary.main,
                  color: 'white',
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>S.No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Requisition No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Requisition Date</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Purchase Date</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Remarks</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: theme.palette.primary.dark, fontSize: '1.1rem' }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((requisition, index) => (
                    <TableRow
                      key={requisition.requisitionId}
                      sx={{
                        backgroundColor: index % 2 === 0 ? theme.palette.background.paper : theme.palette.background.paper,
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                      }}
                    >
                      <TableCell sx={{ fontSize: '1rem' }}>{(page - 1) * rowsPerPage + index + 1}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{requisition.requisitionNo}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{requisition.requisitionDate}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{requisition.purchaseDate}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{requisition.remarks}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          onClick={() => handleEdit(requisition)}
                          sx={{
                            color: theme.palette.primary.light,
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          color="error"
                          onClick={() => handleDelete(requisition.requisitionId, requisition.requisitionNo)}
                          sx={{
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow sx={{
                backgroundColor: theme.palette.background.paper,
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
              }} >
                    <TableCell colSpan={6} align="center" sx={{ fontSize: '1rem', padding: '20px', wordSpacing: 7 }}>
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTableScrollbar>
      </Paper>
      {filteredData.length > 0 && (
        <Box
          sx={{
            maxWidth: '100%',
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 1,
            p: 2,
            mx: 'auto',
            pt: 2,
          }}
        >
          <Typography
            variant="body2"
            color={theme.palette.primary.main}
          >
            Page <strong>{page}</strong> of <strong>{Math.ceil(filteredData.length / rowsPerPage)}</strong>
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton
              onClick={() => handleChangePage(null, page - 1)}
              disabled={page === 1}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronLeft />
            </IconButton>
            {[...Array(Math.ceil(filteredData.length / rowsPerPage))].map((_, index) => (
              <IconButton
                key={index + 1}
                onClick={() => handleChangePage(null, index + 1)}
                sx={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: page === index + 1 ? theme.palette.primary.main : 'transparent',
                  color: page === index + 1 ? theme.palette.primary.contrastText : theme.palette.text.primary,
                  '&:hover': {
                    backgroundColor: page === index + 1 ? theme.palette.primary.dark : theme.palette.action.hover,
                  },
                }}
              >
                {index + 1}
              </IconButton>
            ))}
            <IconButton
              onClick={() => handleChangePage(null, page + 1)}
              disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronRight />
            </IconButton>
            <FormControl size="small" sx={{ minWidth: 100, ml: 1 }}>
              <InputLabel id="rows-per-page-label" sx={{ color: theme.palette.text.primary }}>Rows</InputLabel>
              <Select
                labelId="rows-per-page-label"
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                label="Rows"
                sx={{
                  height: '36px',
                  color: theme.palette.text.primary,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={30}>30</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
      )}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Modal open={showDeleteModal} onClose={handleCloseDeleteModal} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
            <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Delete Confirmation ⚠️
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="delete-modal-description" sx={{ mb: 2 }}>
              Are you sure you want to delete {selectedRequisition.requisitionNo}?
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button onClick={handleCloseDeleteModal} variant="outlined" sx={{ mr: 1 }} data-app-cancel="true">
                Cancel
              </Button>
              <Button variant="contained" color="error" onClick={handleCloseDeleteModal}>
                Yes, Delete
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal open={showAddRequisitionModal} onClose={() => setShowAddRequisitionModal(false)} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 600, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Add Requisition
            </Typography>
            <IconButton onClick={() => setShowAddRequisitionModal(false)} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Requisition No"
                variant="outlined"
                fullWidth
                name="requisitionNo"
                value={formData.requisitionNo}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Requisition Date"
                variant="outlined"
                type="date"
                fullWidth
                name="requisitionDate"
                value={formData.requisitionDate}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
               sx={{
                mb: 3,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
                '& .MuiInputBase-input[type="date"]::-webkit-calendar-picker-indicator': {
                  filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
                },
              }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Purchase Date"
                variant="outlined"
                type="date"
                fullWidth
                name="purchaseDate"
                value={formData.purchaseDate}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
                '& .MuiInputBase-input[type="date"]::-webkit-calendar-picker-indicator': {
                  filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
                },
              }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <FormControl fullWidth>
                <InputLabel id="remarks-label" sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                  Remarks
                </InputLabel>
                <Select
                  labelId="remarks-label"
                  id="remarks"
                  name="remarks"
                  value={formData.remarks}
                  label="Remarks"
                  onChange={handleChange}
                  sx={{
                    '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                    '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                  }}
                >
                  {remarkOptions.map((option) => (
                    <MenuItem key={option.id} value={option.name}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip
                title={
                  !formData.requisitionNo ? 'Enter Requisition No' :
                  !formData.requisitionDate ? 'Select Requisition Date' :
                  !formData.purchaseDate ? 'Select Purchase Date' :
                  !formData.remarks ? 'Select Remarks' : ''
                }
                arrow
              >
                <Button
                  variant="contained"
                  onClick={handleSave}
                  sx={{
                    mr: 2,
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': { backgroundColor: theme.palette.primary.dark },
                  }}
                  disabled={!formData.requisitionNo || !formData.requisitionDate || !formData.purchaseDate || !formData.remarks}
                >
                  SAVE
                </Button>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleReset}
              >
                RESET
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal open={showEditRequisitionModal} onClose={handleCancel} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 600, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Edit Requisition
            </Typography>
            <IconButton onClick={handleCancel} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Requisition No"
                variant="outlined"
                fullWidth
                name="requisitionNo"
                value={formData.requisitionNo}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Requisition Date"
                variant="outlined"
                type="date"
                fullWidth
                name="requisitionDate"
                value={formData.requisitionDate}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
               sx={{
                mb: 3,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
                '& .MuiInputBase-input[type="date"]::-webkit-calendar-picker-indicator': {
                  filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
                },
              }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Purchase Date"
                variant="outlined"
                type="date"
                fullWidth
                name="purchaseDate"
                value={formData.purchaseDate}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                sx={{
                mb: 3,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
                '& .MuiInputBase-input[type="date"]::-webkit-calendar-picker-indicator': {
                  filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
                },
              }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <FormControl fullWidth>
                <InputLabel id="remarks-label" sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                  Remarks
                </InputLabel>
                <Select
                  labelId="remarks-label"
                  id="remarks"
                  name="remarks"
                  value={formData.remarks}
                  label="Remarks"
                  onChange={handleChange}
                  sx={{
                    '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                    '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                  }}
                >
                  {remarkOptions.map((option) => (
                    <MenuItem key={option.id} value={option.name}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip
                title={
                  !formData.requisitionNo ? 'Enter Requisition No' :
                  !formData.requisitionDate ? 'Select Requisition Date' :
                  !formData.purchaseDate ? 'Select Purchase Date' :
                  !formData.remarks ? 'Select Remarks' : ''
                }
                arrow
              >
                <Button
                  variant="contained"
                  onClick={handleUpdate}
                  sx={{
                    mr: 2,
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': { backgroundColor: theme.palette.primary.dark },
                  }}
                  disabled={!formData.requisitionNo || !formData.requisitionDate || !formData.purchaseDate || !formData.remarks}
                >
                  UPDATE
                </Button>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleCancel}
              >
                CANCEL
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal
  open={showUserGuideModal}
  onClose={() => setShowUserGuideModal(false)}
  BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 800,
      bgcolor: 'background.paper',
      borderRadius: '16px',
      boxShadow: 24,
      overflow: 'hidden',
    }}
  >
    {/* Header */}
    <Box
      sx={{
        backgroundColor: theme.palette.primary.main,
        padding: '12px 16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
        Requisition Management - User Guide
      </Typography>
      <IconButton
        onClick={() => setShowUserGuideModal(false)}
        sx={{ color: '#fff', position: 'absolute', right: 14 }}
      >
        <CloseIcon />
      </IconButton>
    </Box>

    {/* Scrollable Content */}
    <CustomTableScrollbar sx={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}>
      {/* Section 1: Add Requisition */}
      <Typography
        variant="body1"
        sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}
      >
       ➤ Follow these steps to add a new requisition:
      </Typography>
      <ul
        style={{
          marginLeft: '20px',
          lineHeight: '1.8',
          cursor: 'pointer',
        }}
      >
        <li>
          Click the <strong>"ADD"</strong> button  next to the search bar.
        </li>
        <li>
          In the "Add Requisition" modal, enter the <strong>Requisition No</strong>.
        </li>
        <li>
          Select the <strong>Requisition Date</strong> using the date picker.
        </li>
        <li>
          Select the <strong>Purchase Date</strong> using the date picker.
        </li>
        <li>
          Choose <strong>Remarks</strong> from the dropdown (Urgent, Standard, etc.).
        </li>
        <li>
          Before clicking <strong>"SAVE"</strong>, ensure all fields are filled (tooltips show missing fields).
        </li>
        <li>
          Click <strong>"SAVE"</strong> to add. A success snackbar will confirm.
        </li>
        <li>
          The new requisition will appear in the table (refresh search/pagination if needed).
        </li>
        <li>
          Use <strong>"RESET"</strong> to clear form fields without saving.
        </li>
      </ul>
      <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
       ⚠️ Note: All fields are required. Added requisitions update the static data in this demo.
      </Typography>

      {/* Section 2: Edit Requisition */}
      <Typography
        variant="body1"
        sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
      >
       ➤ Follow these steps to update an existing requisition:
      </Typography>
      <ul
        style={{
          marginLeft: '20px',
          lineHeight: '1.8',
          cursor: 'pointer',
        }}
      >
        <li>
          In the requisition table, select  the row to update.
        </li>
        <li>
          Click the <strong>Edit</strong> icon (pencil) in the "Action" column.
        </li>
        <li>
          The "Edit Requisition" modal loads with current details.
        </li>
        <li>
          Update <strong>Requisition No</strong>, dates, or <strong>Remarks</strong> as needed.
        </li>
        <li>
          Click <strong>"UPDATE"</strong> (enabled only if all fields filled; tooltips guide).
        </li>
        <li>
          A success snackbar confirms the update.
        </li>
        <li>
          Click <strong>"CANCEL"</strong> or close icon to discard changes.
        </li>
      </ul>
      <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
       ⚠️ Note: Ensure required fields are complete before updating.
      </Typography>

      {/* Section 3: Delete Requisition */}
      <Typography
        variant="body1"
        sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
      >
       ➤ Follow these steps to delete a requisition:
      </Typography>
      <ul
        style={{
          marginLeft: '20px',
          lineHeight: '1.8',
          cursor: 'pointer',
        }}
      >
        <li>
          In the table, locate the row to delete.
        </li>
        <li>
          Click the <strong>Delete</strong> icon button in the "Action" column.
        </li>
        <li>
          A confirmation modal appears showing the Requisition No.
        </li>
        <li>
          Click <strong>"Yes, Delete"</strong> to confirm removal.
        </li>
        <li>
          The row disappears from the table; adjust pagination if needed.
        </li>
        <li>
          Click <strong>"Cancel"</strong> to abort.
        </li>
      </ul>
      <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
       ⚠️ Note: Deletion is immediate and irreversible in this demo. Use with caution.
      </Typography>

      {/* Section 4: Search Requisitions */}
      <Typography
        variant="body1"
        sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
      >
       ➤ Follow these steps to search for requisitions:
      </Typography>
      <ul
        style={{
          marginLeft: '20px',
          lineHeight: '1.8',
          cursor: 'pointer',
        }}
      >
        <li>
          Enter a term in the <strong>Search</strong> bar (top-left, with magnifying glass icon).
        </li>
        <li>
          Search filters by Requisition No, Dates, or Remarks (case-insensitive).
        </li>
        <li>
          Table updates live; pagination adjusts to filtered results.
        </li>
        <li>
          Clear the search to show all data.
        </li>
      </ul>
      <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
       ⚠️ Note: If no matches, "No Data Found" displays in the table.
      </Typography>

      {/* Section 5: Pagination and Rows Per Page */}
      <Typography
        variant="body1"
        sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
      >
       ➤ Follow these steps to navigate pages and adjust rows:
      </Typography>
      <ul
        style={{
          marginLeft: '20px',
          lineHeight: '1.8',
          cursor: 'pointer',
        }}
      >
        <li>
          Below the table, use <strong>left/right arrows</strong> or page number buttons to navigate.
        </li>
        <li>
          Page info shows "Page X of Y".
        </li>
        <li>
          Select rows per page (5, 10, 20, 30) from the "Rows" dropdown.
        </li>
        <li>
          Changing rows resets to page 1; applies to filtered or full data.
        </li>
        <li>
          Arrows disable at first/last page.
        </li>
      </ul>
      <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
       ⚠️ Note: Pagination only shows if data exists; based on filtered results.
      </Typography>

      {/* Bottom Close Button */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        {/* Optional close button if needed */}
      </Box>
    </CustomTableScrollbar>
  </Box>
</Modal>
<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default Requisition;